<template>
  <q-uploader
    ref="imageUploader"
    label="Upload Image"
    accept="image/*"
    auto-upload
    hide-upload-btn
    no-thumbnails
    flat
    color="transparent"
    class="invisible-uploader"
    @added="onAttachImage"
  >
    <template #header>
      <q-btn
        dense
        flat
        size="sm"
        label="Image"
        icon="mdi-image"
        color="black"
        :loading="uploadingImages"
      >
        <q-uploader-add-trigger />
      </q-btn>
    </template>
    <template #list>
      <div />
    </template>
  </q-uploader>
</template>

<script>
import { resizeImage } from 'src/helpers/images'

export default {
  emits: ['run'],
  data () {
    return {
      uploadingImages: false
    }
  },
  methods: {
    onAttachImage (files) {
      if (files && files[0]) {
        try {
          const FR = new FileReader()
          // Shrink the image to a small size
          // And then upload th the server. The server will generate a public URL
          //  which will allow the image to always be available (no signed URL means the link won't expire)
          FR.addEventListener('load', async (e) => {
            const resizedImage = await resizeImage({
              file: e.target.result,
              maxSize: 768
            })
            const formData = new FormData()
            formData.append('is_public', 1)
            formData.append('files[]', resizedImage, files[0].name)
            this.uploadingImages = true
            const { status, payload } = await this.$post('v1/files/upload', formData)
            this.uploadingImages = false
            if (status === 'success') {
              for (const uploadedFile of payload.files) {
                this.$emit('run', 'insertImage', uploadedFile.signed_url)
              }
              this.$q.notify({
                color: 'green',
                message: 'Successfully attached image'
              })
            }
          })
          FR.readAsDataURL(files[0])
        }
        catch (err) {
        }
        finally {
          this.$refs.imageUploader.reset()
        }
      }
    }
  }
}
</script>
